import { useEffect, useState } from 'react'
import Papa from 'papaparse'
import DataGrid from './data-grid'
import { ClipLoader } from 'react-spinners'
import { LoaderWrapper } from '@/pages/product/styled'

const Preview = ({ data }: { data: File }) => {
  const [content, setContent] = useState<{ [id: string]: string }[]>([])
  const [parseError, setParseError] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    setIsLoading(true)
    setParseError(null)

    createCsv(data)
      .then((val) => {
        setContent(val)
        setParseError(null)
      })
      .catch((e) => {
        setParseError('Failed to parse CSV file')
        setContent([])
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [data])

  if (parseError) {
    return (
      <div style={{ color: '#ff6b6b' }}>Error parsing file: {parseError}</div>
    )
  }

  if (isLoading) {
    return (
      <LoaderWrapper>
        <ClipLoader color="#000000" size={30} />
      </LoaderWrapper>
    )
  }

  return (
    <>
      {content.length > 0 && (
        <DataGrid
          height="360px"
          columns={Object.keys(content[0]).map((val) => ({ field: val }))}
          rows={content.map((val, i) => ({ id: i, ...val }))}
        />
      )}
      {content.length === 0 && (
        <div style={{ color: '#858585' }}>No data to preview</div>
      )}
    </>
  )
}

export const createCsv = async (
  data: File,
  limitRows?: number,
): Promise<{ [id: string]: string }[]> => {
  const csvPromise = new Promise<{ [id: string]: string }[]>(
    (resolve, reject) => {
      Papa.parse<{ [id: string]: string }>(data, {
        complete: (results) => {
          // Filter out delimiter warnings - only reject on actual parsing errors
          const actualErrors = results.errors.filter(
            (error) => error.type !== 'Delimiter',
          )

          if (actualErrors.length > 0) {
            reject(actualErrors)
          } else {
            resolve(results.data)
          }
        },
        preview: !limitRows ? 100 : limitRows,
        header: true,
        delimiter: ',',
        skipEmptyLines: true,
      })
    },
  )
  return await csvPromise
}

export default Preview
